import { FC } from 'react';

import { AppBar, IconButton, Stack, Toolbar } from '@mui/material';

import { selectCurrentUser } from '@src/store/auth/auth-selectors';
import { useAppSelector } from '@src/store/store';

import Iconify from '@src/components/iconify';
import LanguageSelector from '@src/components/language-selector';
import { useResponsive } from '@src/hooks/use-responsive';
import { FOOTER_HEADER, MINI_SIDE_BAR, SIDE_BAR } from '@src/layouts/configs';
import useLocales from '@src/locales/use-locales';

import HeaderAccountInfo from '../../components/header-account-info';

type HeaderProps = {
  onOpen: () => void;
  onToggle: () => void;
  isMini: boolean;
};

const Header: FC<HeaderProps> = (props) => {
  const { onOpen, onToggle, isMini } = props;
  const { t } = useLocales();

  const lgUp = useResponsive('up', 'lg');

  const user = useAppSelector(selectCurrentUser);

  return (
    <AppBar
      component="header"
      sx={{
        minHeight: FOOTER_HEADER.HEIGHT,
        boxShadow: 'none',
        backgroundColor: 'background.default',
        borderBottom: (theme) => `1px solid ${theme.palette.custom.darkGrey}`,
        ...(lgUp && {
          width: `calc(100% - ${SIDE_BAR.WIDTH}px)`,
          ...(isMini && { width: `calc(100% - ${MINI_SIDE_BAR.WIDTH}px)` }),
        }),
      }}
    >
      <Toolbar
        sx={{
          backgroundColor: 'background.default',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        {!lgUp && (
          <IconButton
            aria-label={t('ariaLabels.openSideBar')}
            edge="start"
            onClick={onOpen}
          >
            <Iconify
              icon="material-symbols:menu"
              sx={{ color: 'custom.lightGrey' }}
            />
          </IconButton>
        )}

        {lgUp && (
          <IconButton
            onClick={onToggle}
            aria-label={
              isMini ? t('ariaLabels.maxSideBar') : t('ariaLabels.minSideBar')
            }
          >
            <Iconify
              icon={
                isMini
                  ? 'majesticons:menu-expand-right'
                  : 'majesticons:menu-expand-left'
              }
              sx={{ color: 'custom.lightGrey' }}
            />
          </IconButton>
        )}
        <Stack direction="row" sx={{ gap: 1 }}>
          {user && <HeaderAccountInfo user={user} />}
          <LanguageSelector />
        </Stack>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
